import { render, staticRenderFns } from "./setSalaryDialog.vue?vue&type=template&id=a73387a4&scoped=true&"
import script from "./setSalaryDialog.vue?vue&type=script&lang=js&"
export * from "./setSalaryDialog.vue?vue&type=script&lang=js&"
import style0 from "./setSalaryDialog.vue?vue&type=style&index=0&id=a73387a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73387a4",
  null
  
)

export default component.exports